import { createFileRoute } from '@tanstack/react-router'
import { AdminCampaigns } from '@/components/admin/marketing/AdminCampaigns'

// ?open=<campaignId> opens that campaign's editor on arrival — a launched
// marketing kit links here to review and send the draft it created.
type CampaignsSearch = { open?: string }

export const Route = createFileRoute('/admin/marketing/campaigns')({
  validateSearch: (s: Record<string, unknown>): CampaignsSearch =>
    typeof s.open === 'string' && s.open ? { open: s.open } : {},
  component: () => <AdminCampaigns />,
})
